export default {
  talk_to_us: 'Praat met ons:',
  send_us_email: 'Stuur ons een e-mail:',
  visit_website: 'Bezoek onze website:',
  join_our_community: 'Word lid van onze community voor exclusieve aanbiedingen en updates!',
};
